export const styles = theme => ({
    outlined: {
        marginRight: "1rem",
        marginBottom: 8,
        marginTop: 5
    },
    filled: {
        marginRight: "1rem",
        marginBottom: 8,
        marginTop: 5,
        "& input": {
            height: 47,
            fontSize: "0.85rem",
            border: "1px solid #C4C4C4",
        },
        "& label": {
            fontSize: "0.85rem",
            color: "#AFAFAF"
        },
        "& div:before": {
            border: 0
        }
    },
})